/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ProjectCalculationsProfitAndLossPlanExcelRetrieve$Params {
  id: string;
}

export function projectCalculationsProfitAndLossPlanExcelRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsProfitAndLossPlanExcelRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsProfitAndLossPlanExcelRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

projectCalculationsProfitAndLossPlanExcelRetrieve.PATH = '/api/project_calculations/profit_and_loss_plan_excel/{id}/';
